<template>
  <div>
    <el-table :data="tzQclRecord" stripe border height="670" style="width: 100%;height:100%">
      <el-table-column prop="name" label="工序" min-width="15" />
      <el-table-column prop="temperature" label="标准温度" min-width="25" />
      <el-table-column prop="temperature_value" label="处理温度" min-width="20" />
      <el-table-column prop="time" label="标准时间(min)" min-width="20" />
      <el-table-column prop="time_value" label="处理时间(min)" min-width="20" />
    </el-table>
  </div>
</template>

<script>
export default {
  name: "BusTzQclRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return{
      tzQclRecord:[
        {
          name: '脱脂',
          temperature: '52.5(50~55)',
          temperature_value: '',
          time: '5(4~6)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '5(4~6)',
          time_value: ''
        },
        {
          name: '苛性',
          temperature: '40(35~55)',
          temperature_value: '',
          time: '4.5(4~6)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '1(1~2)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '2(1~3)',
          time_value: ''
        },
        {
          name: '酸洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '5(4~6)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '1(1~2)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '2(1~3)',
          time_value: ''
        },
        {
          name: '纯水',
          temperature: '常温',
          temperature_value: '常温',
          time: '2(1~3)',
          time_value: ''
        },
        {
          name: '',
          temperature: '',
          temperature_value: '',
          time: '',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '1(1~2)',
          time_value: ''
        },
        {
          name: '水洗',
          temperature: '常温',
          temperature_value: '常温',
          time: '1(1~2)',
          time_value: ''
        },
        {
          name: '纯水',
          temperature: '常温',
          temperature_value: '常温',
          time: '2(1~3)',
          time_value: ''
        },
        {
          name: '干燥',
          temperature: '80(70~80)',
          temperature_value: '',
          time: '60(40~80)',
          time_value: ''
        },
        {
          name: '温度',
          temperature: '',
          temperature_value: '',
          time: '',
          time_value: ''
        }
      ],
    }
  },
  methods:{
    async getTzQclRecord(){
      let {data: res} = await this.$axios.post('bus/tz/getTzQclRecord',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        console.log(res.data)
        this.tzQclRecord[0].temperature_value = res.data.temperature1
        this.tzQclRecord[2].temperature_value = res.data.temperature2
        this.tzQclRecord[9].temperature_value = res.data.temperature3
        this.tzQclRecord[13].temperature_value = res.data.temperature4
        this.tzQclRecord[14].temperature_value = res.data.temperature5
        for (let i = 0; i < 14;i++){
          this.tzQclRecord[i].time_value = res.data["time"+(i+1)]
        }
        this.tzQclRecord[9].name = res.data.cr.type
        this.tzQclRecord[9].time = res.data.cr.time + "("+res.data.cr.time_down+"~"+res.data.cr.time_up+")"
        this.tzQclRecord[9].temperature = res.data.cr.temperature + "("+res.data.cr.temperature_down+"~"+res.data.cr.temperature_up+")"
      }
    }
  },
  created() {
    this.getTzQclRecord()
  }
}
</script>

<style scoped>

</style>